import { useCallback } from "react";

import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";
import { ChartViewEnum } from "~/feature/chart/types";
import { getGroupedMarketIdsSelection } from "~/feature/chart/utils";

export const useMarketsDataGridChartFocus = () => {
  const { markets, setViewMode } = useCoreChart();

  return useCallback(
    (marketId: string) => {
      if (!markets.some(({ id }) => id === marketId)) {
        return;
      }

      const isGrouped =
        getGroupedMarketIdsSelection(markets, marketId).length > 1;

      setViewMode(
        isGrouped ? ChartViewEnum.CONSENSUS : ChartViewEnum.YES,
        marketId
      );
    },
    [markets, setViewMode]
  );
};
